export default __webpack_public_path__ + "static/media/gear.d3c7c77a.png";